import { cn } from '@/lib/utils';
import React from 'react';
interface SectionTagProps {
  children: React.ReactNode;
  className?: string;
  tone?: 'light' | 'dark';
}

/** Etiqueta de sección: píldora con punto verde mensajería. */
export function SectionTag({
  children,
  className = '',
  tone = 'light'
}: SectionTagProps) {
  return <span className={cn('inline-flex items-center gap-2 rounded-full border px-3.5 py-1.5 font-display text-[0.66rem] font-bold uppercase tracking-editorial', tone === 'dark' ? 'border-graphite-line bg-graphite text-white/70' : 'border-fog bg-white text-wa-deep', className)} data-id="element-184" data-mp="25q9ezybw0ele">
      <span className="h-1.5 w-1.5 rounded-full bg-wa" aria-hidden data-id="element-185" data-mp="2kh0abgcotvt9" />
      {children}
    </span>;
}